import actionTypes from '../../constants/actions/albaran/albaran'

export function fetchAlbaranes(filtros){
  return {
    type: actionTypes.FETCH_ALBARANES,
    filtros
  }
}

export function fetchAlbaranesSuccess(list, filtros){
  return {
    type: actionTypes.FETCH_ALBARANES_SUCCESS,
    list,
    filtros
  }
}

export function seleccionarTodosAlbaranes(){
  return {
    type: actionTypes.SELECCIONAR_TODOS_ALBARANES
  }
}

export function deseleccionarTodosAlbaranes(){
  return {
    type: actionTypes.DESELECCIONAR_TODOS_ALBARANES
  }
}

export function onDeleteAlbaran(idAlbaran) {
  return {
    type: actionTypes.ON_DELETE_ALBARAN,
    idAlbaran
  }
}
export function imprimirAlbaran(idAlbaran) {
  return {
    type: actionTypes.IMPRIMIR_ALBARAN,
    idAlbaran
  }
}
export function deleteSeleccionAlbaranes(list){
  return {
    type: actionTypes.DELETE_SELECCION_ALBARANES,
    list
  }
}

export function crearCsvAlbaranes(list){
  return {
    type: actionTypes.CREATE_CSV_ALBARANES,
    list
  }
}

export function imprimirPdfAlbaranes(list){
  return {
    type: actionTypes.IMPRIMIR_PDF_ALBARANES,
    list
  }
}

export function imprimirDetalleAlbaranes(list){  
  return {
    type: actionTypes.IMPRIMIR_DETALLE_ALBARANES,
    list
  }
}

export function abrirModalVacioAlbaran () {
  return {
    type: actionTypes.ABRIR_MODAL_VACIO_ALBARAN
  }
}

export function abrirModalVacioAlbaranSuccess () {
  return {
    type: actionTypes.ABRIR_MODAL_VACIO_ALBARAN_SUCCESS
  }
}

export function abrirDetallesAlbaran (idAlbaran) {
  return {
    type: actionTypes.ABRIR_DETALLES_ALBARAN,
    idAlbaran
  }
}

export function abrirDetallesAlbaranSuccess (data) {
  return {
    type: actionTypes.ABRIR_DETALLES_ALBARAN_SUCCESS,
    data
  }
}

export function duplicarDatosModalAlbaran(idAlbaran){
  return {
    type: actionTypes.DUPLICAR_DATOS_MODAL_ALBARAN,
    idAlbaran
  }
}

export function cerrarDetallesAlbaran () {
  return {
    type: actionTypes.CERRAR_DETALLES_ALBARAN
  }
}

export function cerrarDetallesAlbaranSuccess () {
  return {
    type: actionTypes.CERRAR_DETALLES_ALBARAN_SUCCESS
  }
}

export function editarAlbaran (values, mostrarMensaje, location, callback) {
  return {
    type: actionTypes.EDITAR_ALBARAN,
    values,
    mostrarMensaje,
    location,
    callback
  }
}

export function seleccionarTodosModalAlbaranDosis(){
  return {
    type: actionTypes.SELECCIONAR_TODOS_MODAL_ALBARAN_DOSIS
  }
}

export function deseleccionarTodosModalAlbaranDosis(){
  return {
    type: actionTypes.DESELECCIONAR_TODOS_MODAL_ALBARAN_DOSIS
  }
}

export function deleteModalAlbaranDosis(idAlbaranDosis) {
  return {
    type: actionTypes.DELETE_MODAL_ALBARAN_DOSIS,
    idAlbaranDosis
  }
}

export function deleteSeleccionModalAlbaranDosis(list){
  return {
    type: actionTypes.DELETE_SELECCION_MODAL_ALBARAN_DOSIS,
    list
  }
}

export function abrirModalVacioAlbaranDosis(){
  return {
    type: actionTypes.ABRIR_MODAL_VACIO_ALBARAN_DOSIS
  }
}

export function abrirModalVacioAlbaranDosisSuccess(){
  return {
    type: actionTypes.ABRIR_MODAL_VACIO_ALBARAN_DOSIS_SUCCESS
  }
}

export function abrirDetallesAlbaranDosis (row) {
  return {
    type: actionTypes.ABRIR_DETALLES_ALBARAN_DOSIS,
    row
  }
}

export function abrirDetallesAlbaranDosisSuccess (data) {
  return {
    type: actionTypes.ABRIR_DETALLES_ALBARAN_DOSIS_SUCCESS,
    data
  }
}

export function cerrarDetallesAlbaranDosis () {
  return {
    type: actionTypes.CERRAR_DETALLES_ALBARAN_DOSIS
  }
}

export function cerrarDetallesAlbaranDosisSuccess () {
  return {
    type: actionTypes.CERRAR_DETALLES_ALBARAN_DOSIS_SUCCESS
  }
}

export function editarAlbaranDosis (values, guardarYnuevo, onSuccessCallback, onErrorCallback) {
  return {
    type: actionTypes.EDITAR_ALBARAN_DOSIS,
    values,
    guardarYnuevo,
    onSuccessCallback,
    onErrorCallback
  }
}

export function editarAlbaranDosisSuccess (list) {
  return {
    type: actionTypes.EDITAR_ALBARAN_DOSIS_SUCCESS,
    list
  }
}

export function calcTotalesAlbaranDosis () {
  return {
    type: actionTypes.CALC_TOTALES_ALBARAN_DOSIS
  }
}

export function calcTotalesAlbaranDosisSuccess (totalesList) {
  return {
    type: actionTypes.CALC_TOTALES_ALBARAN_DOSIS_SUCCESS,
    totalesList
  }
}

export function crearAlbaranDesdePedidoSuccess (data) {
  return {
    type: actionTypes.CREAR_ALBARANES_DESDE_PEDIDO_SUCCESS,
    data
  }
}
export function editarAlbaranEImprimirDatosAlbaran(values, idAlbaran, numeroAlbaran, mostrarMensaje, location){
  return {
    type: actionTypes.EDITAR_ALBARAN_E_IMPRIMIR_DATOS_ALBARAN,
    values,
    idAlbaran,
    numeroAlbaran,
    mostrarMensaje,
    location
  }
}

export function imprimirDatosAlbaran(values, idAlbaran, numeroAlbaran){
  return {
    
    type: actionTypes.IMPRIMIR_DATOS_ALBARAN,
    values,
    idAlbaran,
    numeroAlbaran
  }
}

export function imprimirDatosAlbaranCliente(values, idAlbaran, numeroAlbaran){
  return {
    type: actionTypes.IMPRIMIR_DATOS_ALBARAN_CLIENTE,
    values,
    idAlbaran,
    numeroAlbaran
  }
}

export function imprimirEtiquetaPDF(idAlbaran){
  return {
    type: actionTypes.ALBARAN_PDF_ETIQUETA_PDF,
    idAlbaran
  }
}

export function imprimirEtiquetaPDFSuccess(etiquetaPdf){
  return {
    type: actionTypes.ALBARAN_PDF_ETIQUETA_PDF_SUCCESS,
    etiquetaPdf
  }
}

export function abrirModalAlbaranValidacionRfid(){
  return {
    type: actionTypes.ABRIR_MODAL_ALBARAN_VALIDACION_RFID
  }
}

export function cerrarModalAlbaranValidacionRfid(){
  return {
    type: actionTypes.CERRAR_MODAL_ALBARAN_VALIDACION_RFID
  }
}

export function leerEtiquetasRFID(){
  return {
    type: actionTypes.LEER_ETIQUETA_RFID
  }
}

export function editarAlbaranDosisRFID (list) {
  return {
    type: actionTypes.EDITAR_ALBARAN_DOSIS_RFID,
    list
  }
}

export function asignaParcialRFID(list){  
  return {
    type: actionTypes.ASIGNA_PARCIAL_RFID,
    list
  }
}

export function asignaAcumuladoRFID(value){  
  return {
    type: actionTypes.ASIGNA_ACUMULADO_RFID,
    value
  }
}

export default {
  fetchAlbaranes,
  fetchAlbaranesSuccess,
  seleccionarTodosAlbaranes,
  deseleccionarTodosAlbaranes,
  onDeleteAlbaran,
  imprimirAlbaran,
  deleteSeleccionAlbaranes,
  crearCsvAlbaranes,
  imprimirPdfAlbaranes,
  imprimirDetalleAlbaranes,
  abrirModalVacioAlbaran,
  abrirModalVacioAlbaranSuccess,
  abrirDetallesAlbaran,
  abrirDetallesAlbaranSuccess,
  duplicarDatosModalAlbaran,
  cerrarDetallesAlbaran,
  cerrarDetallesAlbaranSuccess,
  editarAlbaran,
  seleccionarTodosModalAlbaranDosis,
  deseleccionarTodosModalAlbaranDosis,
  deleteModalAlbaranDosis,
  deleteSeleccionModalAlbaranDosis,
  abrirModalVacioAlbaranDosis,
  abrirModalVacioAlbaranDosisSuccess,
  abrirDetallesAlbaranDosis,
  abrirDetallesAlbaranDosisSuccess,
  cerrarDetallesAlbaranDosis,
  cerrarDetallesAlbaranDosisSuccess,
  editarAlbaranDosis,
  editarAlbaranDosisSuccess,
  calcTotalesAlbaranDosis,
  calcTotalesAlbaranDosisSuccess,
  crearAlbaranDesdePedidoSuccess,
  editarAlbaranEImprimirDatosAlbaran,
  imprimirDatosAlbaran,
  imprimirDatosAlbaranCliente,
  imprimirEtiquetaPDF,
  imprimirEtiquetaPDFSuccess,
  abrirModalAlbaranValidacionRfid,
  cerrarModalAlbaranValidacionRfid,
  leerEtiquetasRFID,
  editarAlbaranDosisRFID,
  asignaParcialRFID,
  asignaAcumuladoRFID
}
